import { FC, MouseEvent } from 'react';

import { PLAN_CARD_TEST_ID } from '../constants';
import { ModalTriggerTextButton } from '../PlanCard.styles';

type Props = { children: string; onClick?: (event: MouseEvent<HTMLAnchorElement>) => void };

export const DescriptionModalTriggerButton: FC<Props> = ({ onClick, children }) => {
    return (
        <ModalTriggerTextButton onClick={onClick} dataTest={PLAN_CARD_TEST_ID.DESCRIPTION_MODAL_TRIGGER}>
            {children}
        </ModalTriggerTextButton>
    );
};
